<template>
  <div class="container">
    <div class="columns">
      <div class="column is-6">
        <LsSupportHeader label="Is my lawn mowing scheduled for a specific day of the week?" />
      </div>
    </div>
    <div class="columns">
      <div class="column is-6">
        <p>
          We schedule every service in a two-day window in order to account for any weather,
          traffic, or equipment issues.
        </p>
        <p>If you are rescheduled outside of the window, you'll always be notified.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { LsSupportHeader } from '../components';

export default {
  name: 'WhatDayView',
  components: {
    LsSupportHeader,
  },
};
</script>

<style lang="scss" scoped>
p:not(:last-child) {
  margin-bottom: 16px;
}
</style>
